import React from 'react';

export function ScrollToTopOnMount() {
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
